<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <time-line plain :type="simpleTimeline">
        <time-line-item
          :inverted="(status.psId == 0 || status.psId % 2 == 0) ? true : false"
          badge-type="info"
          badge-icon="assignment"
          v-for="status in project_statuses"
          :key="status.psId"
          class="timeline-desktop"
        >
          <badge slot="header" type="info">#{{status.psId}}: {{status.finishedTitle}}</badge>
          <p slot="content">
            {{status.finishedTitle}} finished by {{status.username}}
          </p>

          <h6 slot="footer">
            <i class="ti-time"></i>
            Completed on: {{status.created_at | formatDate}}
          </h6>
        </time-line-item>

        <time-line-item
          :inverted="true"
          badge-type="info"
          badge-icon="assignment"
          v-for="status in project_statuses"
          :key="status.psId"
          class="timeline-mobile"
        >
          <badge slot="header" type="info">#{{status.psId}}: {{status.finishedTitle}}</badge>
          <p slot="content">
            {{status.finishedTitle}} finished by {{status.username}}
          </p>

          <h6 slot="footer">
            <i class="ti-time"></i>
            Completed on: {{status.created_at | formatDate}}
          </h6>
        </time-line-item>
      </time-line>
    </div>
  </div>
</template>
<script>
  import { TimeLine, TimeLineItem, Badge } from "@/components";
  import moment from 'moment';
  export default {
    components: {
      TimeLine,
      TimeLineItem,
      Badge
    },
    name: 'ProjectOverview',
    props: [
      'showDialog',
      'project_statuses'
    ],
    data() {
      return {
        responsive: false,
      }
    },
    methods: {
      onResponsiveInverted() {
        if (window.innerWidth < 768) {
          this.responsive = true;
        } else {
          this.responsive = false;
        }
      }
    },
    computed: {
      simpleTimeline() {
        if (this.responsive) {
          return "simple";
        }
        return "";
      }
    },
    mounted() {
      this.onResponsiveInverted();
      window.addEventListener("resize", this.onResponsiveInverted);
      console.log(this.project_statuses);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.onResponsiveInverted);
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(String(value)).format('MM/DD/YYYY')
        }
      }
    }
  }

</script>
<style lang="scss" scoped>

</style>
